// Page-build status vocabulary and the auto-check report reading, shared by
// the PM's Page build panel and the build team's package page (moved out of
// DeploymentPanel.js 2026-10-22 so the partner page doesn't import the PM's
// page module).
import { HUES, STATE } from './wizardTheme';

// The auto-check report is pass/fail only (Edward, 2026-10-22: "skipped is
// confusing"): a check with nothing to verify is left out; one that couldn't
// run (no readable text, renderer unavailable) is a fail marked `unverified`.
// Reports stored before that change still say "skipped"; normalizeCheck
// reads them the same way.
const COULD_NOT_RUN = /headless renderer|almost no (visible|static) text|could not be stored/i;

function normalizeCheck(c) {
  if (c.status !== 'skipped') return c;
  if (!COULD_NOT_RUN.test(c.detail || '')) return null;
  return { ...c, status: 'fail', unverified: true,
           detail: `Couldn't check this — look at the page yourself: ${c.detail}` };
}

export function reportChecks(report) {
  return (report?.checks || []).map(normalizeCheck).filter(Boolean);
}

// Real findings only — what the correction composer pre-ticks and the build
// team is shown.
export function failedChecks(report) {
  return reportChecks(report).filter(c => c.status === 'fail' && !c.unverified);
}

export const BUILD_STATUS_LABELS = {
  assigned: 'With the build team',
  url_submitted: 'URL submitted — review',
  checked: 'Checked — review',
  corrections_requested: 'Corrections requested',
  accepted: '✓ Accepted',
};

// Page-status pills take the colors of whoever holds that page — the same
// family as CiqBallChips: build team blue, your-move (DemandArc review) amber,
// accepted green. Shared with the build team's screens.
export const BUILD_STATUS_PILL = {
  assigned: [HUES.strategy.text, HUES.strategy.tint],
  corrections_requested: [HUES.strategy.text, HUES.strategy.tint],
  url_submitted: [STATE.gate.text, STATE.gate.tint],
  checked: [STATE.gate.text, STATE.gate.tint],
  accepted: [STATE.done.text, STATE.done.tint],
};
